[
    {
        "planCategory": "my assets",
        "categoryDescription":"Plan Review lists out all the items in your plan, making it easy for you to update or delete your existing items as well as adding new ones to your plan.",
        "sections": [
            "bank accounts",
            "managed portfolio",
            "pensions",
            "items of value",
            "property",
            "listed shares",
            "unlisted shares",
            "financial products",
            "money owed to me",
            "national savings and investment",
            "other assets"
        ],
        "sectionsTemplateBaseNames":[
            "bank-account",
            "managed-portfolio",
            "pension",
            "item-of-value",
            "property",
            "listed-share",
            "unlisted-share",
            "financial-product",
            "money-owed-to-me",
            "national-savings-and-investment",
            "other-asset"
        ],
        "sectionObjects":[
            {"section":"bank accounts","sectionDescription":"bank accounts description","baseName":"bank-account","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"managed portfolio","sectionDescription":"managed portfolio description","baseName":"managed-portfolio","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"pensions","sectionDescription":"pensions description","baseName":"pension","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"items of value","sectionDescription":"items of value description","baseName":"item-of-value","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"property","sectionDescription":"property description","baseName":"property","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"listed shares","sectionDescription":"listed shares description","baseName":"listed-share","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"unlisted shares","sectionDescription":"unlisted shares description","baseName":"unlisted-share","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"financial products","sectionDescription":"financial products description","baseName":"financial-product","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"money owed to me","sectionDescription":"money owed to me description","baseName":"money-owed-to-me","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"national savings and investment","sectionDescription":"national savings and investment description","baseName":"national-savings-and-investment","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"other assets","sectionDescription":"other assets description","baseName":"other-asset","icon":"fa fa-2x fas fa-piggy-bank"}
        ]        
    },
    {
        "planCategory": "my debts",
        "categoryDescription":"Plan Review lists out all the items in your plan, making it easy for you to update or delete your existing items as well as adding new ones to your plan.",
        "sections": [
            "mortgages",
            "credit cards",
            "tax debts",
            "leased items",
            "loans"
        ],
        "sectionsTemplateBaseNames":[
            "mortgage",
            "credit-card",
            "tax-debt",
            "leased-item",
            "loan"
        ],
        "sectionObjects":[
            {"section":"mortgages","sectionDescription":"mortgages description","baseName":"mortgage","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"credit cards","sectionDescription":"credit cards description","baseName":"credit-card","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"tax debts","sectionDescription":"tax debts description","baseName":"tax-debt","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"leased items","sectionDescription":"leased items description","baseName":"leased-item","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"loans","sectionDescription":"loans description","baseName":"loan","icon":"fa fa-2x fas fa-piggy-bank"}
        ]
    },
    
    {
        "planCategory": "my daily life",
        "categoryDescription":"Plan Review lists out all the items in your plan, making it easy for you to update or delete your existing items as well as adding new ones to your plan.",
        "sections": [
            "utilities",
            "insurance",
            "pets",
            "important contacts",
            "important documents",
            "roles",
            "rent",
            "online accounts",
            "memberships",
            "work",
            "healthcare",
            "medications",
            "lifetime gifts",
            "general expenses",
            "others"
        ],
        "sectionsTemplateBaseNames":[
            "utility",
            "insurance",
            "pet",
            "important-contact",
            "important-document",
            "role",
            "rent",
            "online-account",
            "membership",
            "work",
            "healthcare",
            "medication",
            "life-time-gift",
            "general-expense",
            "other"
        ],
        "sectionObjects":[
            {"section":"utilities","sectionDescription":"utilities description","baseName":"utility","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"insurance","sectionDescription":"insurance description","baseName":"insurance","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"pets","sectionDescription":"pets description","baseName":"pet","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"important contacts","sectionDescription":"important contact description","baseName":"important-contact","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"important documents","sectionDescription":"important document description","baseName":"important-document","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"roles","sectionDescription":"roles description","baseName":"role","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"rent","sectionDescription":"rent description","baseName":"rent","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"online accounts","sectionDescription":"online accounts description","baseName":"online-account","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"memberships","sectionDescription":"memberships description","baseName":"membership","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"work","sectionDescription":"work description","baseName":"work","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"healthcare","sectionDescription":"healthcare description","baseName":"healthcare","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"medications","sectionDescription":"medications description","baseName":"medication","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"lifetime gifts","sectionDescription":"lifetime gift description","baseName":"life-time-gift","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"general expenses","sectionDescription":"general expenses description","baseName":"general-expense","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"others","sectionDescription":"others description","baseName":"other","icon":"fa fa-2x fas fa-piggy-bank"}
            
        ]
    },
    {
        "planCategory": "my digital life",
        "categoryDescription":"Plan Review lists out all the items in your plan, making it easy for you to update or delete your existing items as well as adding new ones to your plan.",
        "sections": [
            "domain names",
            "social media",
            "digital legacy",
            "digital devices",
            "password managers",
            "email",
            "cloud storage",
            "e-commerce",
            "loyalty accounts",
            "other digital accounts"
            
            
        ],
        "sectionsTemplateBaseNames":[
            "domain-name",
            "social-media",
            "digital-legacy",
            "digital-device",
            "password-manager",
            "email",
            "cloud-storage",
            "e-commerce",
            "loyalty-account",
            "other-digital-account"
            
        ],
        "sectionObjects":[
            {"section":"domain names","sectionDescription":"domain names description","baseName":"domain-name","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"social media","sectionDescription":"social media description","baseName":"social-media","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"digital legacy","sectionDescription":"digital legacy description","baseName":"digital-legacy","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"digital devices","sectionDescription":"digital devices description","baseName":"digital-device","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"password managers","sectionDescription":"password managers description","baseName":"password-manager","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"email","sectionDescription":"email description","baseName":"email","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"cloud storage","sectionDescription":"cloud storage description","baseName":"cloud-storage","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"e-commerce","sectionDescription":"e-commerce description","baseName":"e-commerce","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"loyalty accounts","sectionDescription":"loyalty accounts description","baseName":"loyalty-account","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"other digital accounts","sectionDescription":"other digital accounts description","baseName":"other-digital-account","icon":"fa fa-2x fas fa-piggy-bank"}
        ]
    },
    {
        "planCategory": "my wishes",
        "categoryDescription":"Plan Review lists out all the items in your plan, making it easy for you to update or delete your existing items as well as adding new ones to your plan.",
        "sections": [
            "will",
            "power of attorney",
            "charities",
            "people to notify",
            "other wishes"
        ],
        "sectionsTemplateBaseNames":[
            "will",
            "power-of-attorney",
            "charity",
            "people-to-notify",
            "other-wish"
        ],
        "sectionObjects":[
            {"section":"will","sectionDescription":"will description","baseName":"will","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"power of attorney","sectionDescription":"power of attorney description","baseName":"power-of-attorney","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"charities","sectionDescription":"charities description","baseName":"charity","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"people to notify","sectionDescription":"people to notify description","baseName":"people-to-notify","icon":"fa fa-2x fas fa-piggy-bank"},
            {"section":"other wishes","sectionDescription":"other wishes description","baseName":"other-wish","icon":"fa fa-2x fas fa-piggy-bank"}
        ]
    },
    {
        "planCategory": "financial summaries",
        "categoryDescription":"",
        "sections": [
            ""
        ],
        "sectionsTemplateBaseNames":[
            ""
        ],
        "sectionObjects":[
            
        ]
    }
]
